<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>标签选择</p>
            </div>
            <div v-show="!info.isWrite" class="tag selectTag">
                <div class="title">
                    <p>分类标签</p>
                    <i>(选择一个)</i>
                </div>
                <div class="tagList">
                    <p v-for="(item,index) in firstList" :key="index" @click="getTags(item.tagId,item)" :class="{on: item.selected}">{{item.tagName}}</p>
                </div>
            </div>
            <div v-if="info.isWrite" class="tag selectTag">
                <div class="title">
                    <p>地域标签</p>
                    <i>(选择一个)</i>
                </div>
                <div class="tagList1">
                    <ul>
                        <li :class="{on: locationIndex == index}" @click="changeLocationIndex(index)" v-for="(item,index) in info.writeTagList.location" :key="index">{{item.tab}}</li>
                    </ul>
                    <div>
                        <div class="ntitle" v-if="info.writeTagList.location[locationIndex] && info.writeTagList.location[locationIndex].list.length > 0">可选标签</div>
                        <p @click="locationSet(index)" v-for="(item,index) in info.writeTagList.location[locationIndex] && info.writeTagList.location[locationIndex].list" :key="index" :class="{on: item.selected}">{{item.name}}<i></i></p>
                    </div>
                </div>
            </div>
            <div v-if="info.isWrite" class="tag selectTag">
                <div class="title">
                    <p>特色标签</p>
                    <i>(选择一个)</i>
                </div>
                <div class="tagList1">
                    <ul>
                        <li :class="{on: specialIndex == index}" @click="changeSpecialIndex(index)" v-for="(item,index) in info.writeTagList.special" :key="index">{{item.tab}}</li>
                    </ul>
                    <div>
                        <div class="ntitle" v-if="info.writeTagList.special[specialIndex] && info.writeTagList.special[specialIndex].list.length > 0">可选标签</div>
                        <p @click="specialSet(index)" v-for="(item,index) in info.writeTagList.special[specialIndex] && info.writeTagList.special[specialIndex].list" :key="index" :class="{on: item.selected}">{{item.name}}<i></i></p>
                    </div>
                </div>
            </div>
            <div v-show="!info.isWrite && secondList && secondList.length > 0" class="tag specialTag">
                <div class="title">
                    <p>特色标签</p>
                    <i>(选择多个)</i>
                </div>
                <div class="tagList">
                    <p @click="getSecondTag(item)" v-for="(item,index) in secondList" :key="index" :class="{on: item.selected}">{{item.tagName}}</p>
                </div>
            </div>
            <div v-show="info && info.platform_key == 'b_plus' && thirdList && thirdList.length > 0" class="tag specialTag">
                <div class="title un">
                    <p>自定义标签</p>
                    <i>(选择多个)</i>
                </div>
                <div class="tagList">
                    <p @click="getThirdTag(item)" v-for="(item,index) in thirdList" :key="index" :class="{on: item.selected}">{{item.tagName}}</p>
                </div>
            </div>
            <div v-show="info && info.platform_key != 'b_plus'" class="tag customTag">
                <div :class="{title: true,on: info.isWrite,red: info.platform_key == 'new_media_knews'}">
                    <p>自定义标签</p>
                </div>
                <input v-model="tagInput" @keydown.enter="tagEnter" type="text" placeholder="按回车键Enter创建标签">
                <div v-if="info.isWrite && info.mediaType == 6" @click="generateTag" class="btn">一键生成标签</div>
            </div>
            <div v-show="info && info.platform_key != 'b_plus'" class="tag">
                <div class="op"></div>
                <ul>
                    <li v-for="(item,index) in tagList" :key="index"><p>{{item}}</p><i @click="del(index)"></i></li>
                </ul>
            </div>
            <div v-show="info && info.platform_key == 'b_plus'" class="tag customTag">
                <div :class="{title1: true}">
                    <p>自定义标签</p>
                </div>
                <input v-model="bTagInput" @keydown.enter="bTagEnter" type="text" placeholder="按回车键Enter创建标签">
            </div>
            <div v-show="info && info.platform_key == 'b_plus'" class="tag">
                <div class="op"></div>
                <ul>
                    <li v-for="(item,index) in bTagList" :key="index"><p>{{item}}</p><i @click="del(index)"></i></li>
                </ul>
            </div>
            <div class="btns-container">
                <p @click="submitTag" class="btn on">确定</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "@common/common";
    import { apis } from "@common/config";

    export default {
        data() {
            return {
                show: true,
                c: null,
                info: {},
                firstList: [],
                secondList: [],
                tagList: [],
                tagInput: '',
                bTagInput: '',
                locationIndex: 999,
                specialIndex: 999,
                thirdList: [],
                savegetTags: '',
                bTagList: []
            }
        },
        methods: {
            changeLocationIndex(index) {
                if(this.info.writeTagList.location[this.locationIndex] && this.info.writeTagList.location[this.locationIndex].list.length > 0){
                    this.info.writeTagList.location[this.locationIndex].list.forEach(el => {
                        el.selected = false;
                    })
                }

                if(this.locationIndex == index){
                  this.locationIndex = 999;
                }else{
                  this.locationIndex = index;
                }
                
            },
            changeSpecialIndex(index) {
                if(this.info.writeTagList.special[this.specialIndex] && this.info.writeTagList.special[this.specialIndex].list.length > 0){
                    this.info.writeTagList.special[this.specialIndex].list.forEach(el => {
                        el.selected = false;
                    })
                }

                if(this.specialIndex == index){
                  this.specialIndex = 999
                }else{
                  this.specialIndex = index
                }
                
            },
            locationSet(index) {
                this.info.writeTagList.location[this.locationIndex].list.forEach((value,key) => {
                    if(key == index){
                        if(value.selected){
                            value.selected = false
                        }else{
                            value.selected = true
                        }
                    }else{
                        value.selected = false
                    }
                })
                // this.info.writeTagList.location.forEach(item => {
                //     item.list.forEach(el => {
                //         el.selected = false
                //     })
                // })

                // if(this.info.writeTagList.location[this.locationIndex].list[index].selected){
                //     this.info.writeTagList.location[this.locationIndex].list[index].selected = false
                // }else{
                //     this.info.writeTagList.location[this.locationIndex].list[index].selected = true
                // }

                // this.$forceUpdate()
                // let location = this.info.writeTagList.location
                // location.forEach(item => {
                //     item.list.forEach(el => {
                //         el.selected = false
                //     })
                // })

                // console.log(location[this.locationIndex].list[index].selected)

                // if(location[this.locationIndex].list[index].selected){
                //     location[this.locationIndex].list[index].selected = false
                // }else{
                //     location[this.locationIndex].list[index].selected = true
                // }

                // this.info.writeTagList.location = location

            },
            specialSet(index) {
                this.info.writeTagList.special[this.specialIndex].list.forEach((value,key) => {
                    if(key == index){
                        if(value.selected){
                            value.selected = false
                        }else{
                            value.selected = true
                        }
                    }else{
                        value.selected = false
                    }
                })
                // let special = this.info.writeTagList.special
                // special.forEach(item => {
                //     item.list.forEach(el => {
                //         el.selected = false
                //     })
                // })

                // special[this.specialIndex].list[index].selected = true
            },
            del(index) {
                this.tagList = this.tagList.filter((el,key) => {
                    return key != index
                })
            },
            tagEnter() {
                if(this.tagInput){
                    let tagList = this.tagList;
                    tagList.push(this.tagInput)
                    this.tagInput = ''
                    this.tagList = Array.from(new Set(tagList))
                }else{
                    this.$toast('内容不能为空')
                }
                // console.log(99)
            },
            bTagEnter() {
                if(this.bTagInput){
                    let bTagList = this.bTagList;
                    bTagList.push(this.bTagInput)
                    this.bTagInput = ''
                    this.bTagList = Array.from(new Set(bTagList))
                }else{
                    this.$toast('内容不能为空')
                }
                // console.log(99)
            },
            generateTag() {
                const contentData = common.escapeEscapes(common.cleanHtmlTags(this.info.content));

                if(contentData){
                    const info = {
                        content: contentData,
                        topnum: 5
                    };

                    common.myFetch(apis.split_words, info).then(r => {
                        if (r) {
                            const arrObj = {};

                            r.forEach(i => {
                                arrObj[i] = "a";
                            });

                            const res = [];

                            for (const k in arrObj) {
                                if (arrObj[k] === "a") {
                                    res.push(k);
                                }
                            }

                            let tagList = this.tagList;

                            tagList = tagList.concat(res);

                            this.tagList = Array.from(new Set(tagList))
                        }
                    });
                }else{
                    this.$toast('内容不能为空')
                }
            },

            getCustomTags(tagId,subTagId) {
                const info = {
                    platform_key: this.info.platform_key,
                    column_key: this.info.column_key,
                    tagId: tagId,
                    subTagId: subTagId,
                    id: this.info.id
                };
                common.myFetch(apis.cmstags, info).then(r => {
                    if(r){
                        console.log(r)
                        this.thirdList = r.list

                        if(r.input_tag_name && r.input_tag_name.length){
                            this.bTagList = r.input_tag_name
                        }else{
                            this.bTagList = []
                        }
                    }
                })
            },
            open(res, c) {
                console.log(res)
                this.info = res || {}
                this.c = c;
                if(!res.isWrite){
                    this.getTags(undefined,null)
                }else{
                    // console.log()
                    res.writeTagList.location.forEach((el,index) => {
                        el.list.forEach(item => {
                            if(item.selected){
                                this.locationIndex = index
                            }
                        })
                    })

                    if(this.locationIndex == 999){
                        res.writeTagList.location.forEach((el,index) => {
                            if(el.selected){
                                this.locationIndex = index
                            }
                        })
                    }

                    res.writeTagList.special.forEach((el,index) => {
                        el.list.forEach(item => {
                            if(item.selected){
                                this.specialIndex = index
                            }
                        })
                    })

                    if(this.specialIndex == 999){
                        res.writeTagList.special.forEach((el,index) => {
                            if(el.selected){
                                this.specialIndex = index
                            }
                        })
                    }
                    this.tagList = res.inputTags
                }
                this.show = true;
            },
            close() {
                this.show = false;
                this.c(false)
            },
            getSecondTags(tagId) {
                const info = {
                    platform_key: this.info.platform_key,
                    column_key: this.info.column_key,
                    tagId: tagId || 0,
                    id: this.info.id
                };
                common.myFetch(apis.newMediaPlatformtags, info).then(data => {
                    if (data) {
                        this.secondList = data.list
                        this.tagList = data.input_tags

                        if(this.info.platform_key == 'b_plus'){
                            let subId = []
                            this.secondList.forEach(el => {
                                if(el.selected){
                                    subId.push(el.tagId)
                                }
                            })
                            subId = subId.join(',')
                            this.savegetTags = tagId
                            this.getCustomTags(tagId,subId)
                        }
                    }
                });
            },
            getTags(tagId,item) {
                if(tagId){
                    if(item && item.selected){
                        this.secondList = []
                        item.selected = false;
                    }else{
                        const info = {
                            platform_key: this.info.platform_key,
                            column_key: this.info.column_key,
                            tagId: tagId,
                            id: this.info.id
                        };

                        common.myFetch(apis.newMediaPlatformtags, info).then(data => {
                            if (data) {
                                if(!tagId){
                                    this.firstList = data.list
                                }else{
                                    this.secondList = data.list
                                }
                                console.log(data)
                            }
                        });
                        this.firstList.forEach(el => {
                            el.selected = false;
                        })
                        item.selected = true
                    }

                    if(this.info.platform_key == 'b_plus'){
                        this.savegetTags = tagId
                        this.getCustomTags(tagId,'')
                    }
                    
                }else{
                    const info = {
                        platform_key: this.info.platform_key,
                        column_key: this.info.column_key,
                        tagId: tagId || 0,
                        id: this.info.id
                    };

                    common.myFetch(apis.newMediaPlatformtags, info).then(data => {
                        if (data) {
                            if(!tagId){
                                let newTag = ''
                                this.firstList = data.list
                                data.list.forEach(el => {
                                    if(el.selected){
                                        newTag = el.tagId
                                    }
                                })
                                if(newTag){
                                    this.getSecondTags(newTag)
                                }
                            }else{
                                this.secondList = data.list
                            }

                            console.log(44444444,data)
                        }
                    });
                }
            },
            getSecondTag(item) {
                item.selected = !item.selected
                let subId = []

                if(this.secondList && this.secondList.length > 0){
                    this.secondList.forEach(el => {
                        if(el.selected){
                            subId.push(el.tagId)
                        }
                    })
                }

                subId = subId.join(',')
                
                if(this.info && this.info.platform_key == 'b_plus'){
                    this.getCustomTags(this.savegetTags,subId)
                }
            },
            getThirdTag(item) {
                item.selected = !item.selected
            },
            submitTag() {
                if(this.info.isWrite){
                    let tagId = ''
                    let sub_tagId = ''
                    let tagListArr = this.tagList;
                    let tagList = this.tagList.join(',');
                    this.info.writeTagList.location.forEach(item => {
                        item.list.forEach(el => {
                            if(el.selected){
                                tagId = el.name
                            }
                        })
                    })

                    if(!tagId){
                        tagId = this.info.writeTagList.location[this.locationIndex] && this.info.writeTagList.location[this.locationIndex].tab
                    }

                    this.info.writeTagList.special.forEach(item => {
                        item.list.forEach(el => {
                            if(el.selected){
                                sub_tagId = el.name
                            }
                        })
                    })

                    if(!sub_tagId){
                        sub_tagId = this.info.writeTagList.special[this.specialIndex] && this.info.writeTagList.special[this.specialIndex].tab
                    }

                    if(this.info.platform_key == 'new_media_knews' && tagList.length == 0){
                        this.$toast('请创建自定义标签')
                        return
                    }

                    if(tagId && sub_tagId){
                        const info = {
                            id: this.info.id,
                            tagId: tagId,
                            sub_tagId: sub_tagId,
                            input_tags: tagList
                        };

                        common.myFetch(apis.newMediaPlatformSaveTags, info).then(data => {
                            if (data) {
                                console.log(data)
                                this.$toast(data)
                                this.c({
                                    tagId,
                                    sub_tagId,
                                    tagListArr
                                })
                                this.show = false;
                            }
                        });
                    }else{
                        this.$toast('请选择标签')
                    }


                }else{
                    let firstTag = '';
                    let firstTagName = '';
                    let secondTag = [];
                    let secondTagName = [];
                    let tagListArr = this.tagList;
                    let tagList = this.tagList.join(',');
                    let customArr = []
                    let customNameArr = []
                    this.firstList.forEach(el => {
                        if(el.selected){
                            firstTag = el.tagId
                            firstTagName = el.tagName
                        }
                    })
                    this.secondList.forEach(el => {
                        if(el.selected){
                            secondTag.push(el.tagId)
                            secondTagName.push(el.tagName)
                        }
                    })
                    secondTag = secondTag.join(',')

                    if(this.info && this.info.platform_key == 'b_plus'){
                        this.thirdList.forEach(el => {
                            if(el.selected){
                                customArr.push(el.tagId)
                                customNameArr.push(el.tagName)
                            }
                        })

                        tagList = customArr.join(',')
                        tagListArr = customArr
                    }

                    if(firstTag && secondTag){
                        const info = {
                            id: this.info.id,
                            tagId: firstTag,
                            sub_tagId: secondTag,
                            input_tags: tagList,
                            input_tag_name: this.bTagList.length ? this.bTagList.join(',') : '',
                        };

                        common.myFetch(apis.newMediaPlatformSaveTags, info).then(data => {
                            if (data) {
                                console.log(data)
                                this.$toast(data)
                                this.c({
                                    firstTagName,
                                    secondTagName,
                                    tagListArr
                                })
                                this.show = false;
                            }
                        });
                        console.log(firstTag,secondTag,tagList)
                    }else{
                        this.$toast('请选择标签')
                    }
                }

                this.bTagList = []
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;

    .box-container {
        width: 880px;
        min-height: 372px;
        padding: 20px 30px 24px;
        background: #F9F9F9;
        border-radius: 4px;
        box-sizing: border-box;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            p {
                font-size: 24px;
                color: #323B4B;
                line-height: 33px;
                font-weight: bold;
            }
        }

        .tag {
            display: flex;
            flex-direction: row;
            width: 100%;

            &.selectTag {

                align-items: baseline;
                .tagList {
                    border-bottom: 1px solid #F0F0F0;
                    box-sizing: border-box;
                }
            }

            &.customTag {
                align-items: center;

                input {
                    width: 530px;
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 104px;
                    height: 30px;
                    background: @green;
                    border-radius: 4px;
                    font-size: 14px;
                    line-height: 20px;
                    color: #FFF;
                    font-weight: bold;
                    margin-left: 16px;
                    user-select: none;
                    cursor: pointer;
                }
            }

            .op {
                min-width: 81px;
            }

            &>ul {
                flex: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                margin-top: 20px;

                &>li {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    height: 24px;
                    padding: 0 10px 0 14px;
                    box-sizing: border-box;
                    background: rgba(185,195,195,0.2);
                    margin: 0 10px 10px 0px;

                    p {
                        font-size: 13px;
                        line-height: 24px;
                        color: #323B4B;
                    }

                    i {
                        display: block;
                        width: 10px;
                        height: 10px;
                        background: url('../../assets/img/mediaPublish/delIcon.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-left: 14px;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }

            .title1 {
                position: relative;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                color: #666;
                min-width: 81px;
                margin-top: 5px;

                i {
                    font-size: 12px;
                    color: #829191;
                }
            }

            .title {
                position: relative;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                color: #666;
                min-width: 81px;
                margin-top: 5px;

                i {
                    font-size: 12px;
                    color: #829191;
                }

                &.on {
                    &::before {
                        position: absolute;
                        top: -10px;
                        left: -10px;
                        display: none;
                        content: '*';
                        font-size: 24px;
                        color: #FF555A;
                    } 
                }

                &.red {
                    &::before {
                        position: absolute;
                        top: -10px;
                        left: -10px;
                        display: block;
                        content: '*';
                        font-size: 24px;
                        color: #FF555A;
                    } 
                }

                &.un {
                    &::before {
                        position: absolute;
                        top: -10px;
                        left: -10px;
                        display: block;
                        content: '';
                        font-size: 24px;
                    }
                }

                &::before {
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    display: block;
                    content: '*';
                    font-size: 24px;
                    color: #FF555A;
                }
            }

            .tagList1 {
                display: flex;
                flex-direction: column;
                flex: 1;
                border-bottom: 1px solid #F0F0F0;
                box-sizing: border-box;
                margin-bottom: 30px;                                                                

                & > ul {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;

                    li {
                        font-size: 14px;
                        text-align: center;
                        height: 30px;
                        line-height: 30px;
                        color: #829191;
                        margin-right: 10px;
                        margin-bottom: 20px;
                        user-select: none;
                        padding: 0 26px;
                        box-sizing: border-box;
                        border-radius: 20px;
                        border: 1px solid rgba(130,145,145,0.5);
                        cursor: pointer;

                        &.on {
                            // position: relative;
                            color: @green;
                            font-weight: bold;
                            border: 1px solid @green;
                            
                            // &:after {
                            //     position: absolute;
                            //     top: 23px;
                            //     left: 0;
                            //     display: block;
                            //     content: '';
                            //     width: 28px;
                            //     height: 3px;
                            //     background: @green;
                            // }
                        }
                    }
                }
                
                &>div {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    flex: 1;

                    .ntitle {
                        position: absolute;
                        left: -81px;
                        top: 6px;
                        font-size: 13px;
                        color: #666666;
                        line-height: 18px;
                    }
                    // margin-bottom: 20px;
                }

                p {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 20px;
                    padding: 0 26px;
                    border: 1px solid rgba(130,145,145,0.5);
                    box-sizing: border-box;
                    font-size: 14px;
                    color: #829191;
                    margin: 0 10px 20px 0;
                    user-select: none;
                    cursor: pointer;

                    i {
                        display: none;
                        // position: absolute;
                        // right: 10px;
                        width: 10px;
                        height: 10px;
                        background: url('../../assets/img/mediaPublish/gdel.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-left: 10px;
                    }

                    &.on {
                        color: @green;
                        border: 1px solid @green;
                        box-sizing: border-box;
                        font-weight: bold;

                        // &:hover {
                        //     color: @green;
                        //     border: 1px solid @green;
                        //     box-sizing: border-box;
                        //     font-weight: bold;
                        //     padding: 0 16px !important;

                        //     i {
                        //         display: block;
                        //     }
                        // }
                        // padding: 0 16px !important;

                        // i {
                        //     display: block;
                        // }
                    }
                }
            }

            .tagList {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                flex: 1;
                margin-bottom: 20px;

                p {
                    height: 30px;
                    line-height: 30px;
                    border-radius: 20px;
                    padding: 0 26px;
                    border: 1px solid #829191;
                    box-sizing: border-box;
                    font-size: 14px;
                    color: #829191;
                    margin: 0 10px 20px 0;
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        color: @green;
                        border: 1px solid @green;
                        box-sizing: border-box;
                        font-weight: bold
                    }
                }
            }

            input {
                width: 530px;
                height: 30px;
                background: #F3F5F6;
                border-radius: 2px;
                padding: 0 14px;
                box-sizing: border-box;

                &::placeholder {       
                    color: #C4CBD1;
                }
            }
        }
        .btns-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-top: 24px;

            .btn {
                width: 120px;
                height: 32px;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                line-height: 32px;
                font-weight: bold;
                text-align: center;
                color: #FFF;
                user-select: none;
                cursor: pointer;

                &.on {
                    background: #41B48C;
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>